var chartJscolors = [
    "86,140,225",
    "226,128,44",
    "23,161,65",
    "237,199,34",
    "176,131,69",
    "207,85,22",
    "121,6,39",
    "188,57,49",
    "48,189,155",
    "155,83,182",
    "195,193,53",
    "155,165,166",
    "149,155,35",
    "50,176,96",
    "30,130,148",
    "59,207,113",
    "255,199,34",
    "53,91,153",
    "20,33,61",
    "140,0,99",
    "198,0,112",
    "94,24,129",
    "54,72,94",
    "48,48,48",
    "69,42,9",
    "226,76,66",
    "164,136,115",
    "145,92,54",
    "227,195,85",
    "179,92,156",
    "12,76,76",
    "91,9,69",
    "227,204,177",
    "0,0,0",
    "64,171,221",
    "255,42,0",
    "220,220,220"
];


var lineLegend = function(chart) {
    var legendHtml = [];
    legendHtml.push('<ul class="' + chart.config.type + '-legend">');

    for (var i=0; i < chart.data.datasets.length; i++) {
        legendHtml.push('<li><span style="background-color:' + chart.data.datasets[i].borderColor + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;' + chart.data.datasets[i].label + '</span></li>');
    }

    legendHtml.push('</ul>');

    var legend = $(chart.canvas).next('.dnJsChart-chart-legend');

    if (typeof legend !== "undefined") {
        legend.html(legendHtml.join(""));
    }
};

var customTooltips = function(tooltip) {
    // Tooltip Element
    var tooltipEl = document.getElementById('dnJsChart-tooltip');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'dnJsChart-tooltip';
        tooltipEl.innerHTML = '<table></table>';
        document.getElementsByTagName('body')[0].appendChild(tooltipEl);
    }

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltip.yAlign) {
        tooltipEl.classList.add(tooltip.yAlign);
    } else {
        tooltipEl.classList.add('no-transform');
    }

    function getBody(bodyItem) {
        return bodyItem.lines;
    }

    // Set Text
    if (tooltip.body) {
        var titleLines = tooltip.title || [];
        var bodyLines = tooltip.body.map(getBody);

        var innerHtml = '';

        if (titleLines.length) {
            innerHtml += '<thead>';

            titleLines.forEach(function(title) {
                innerHtml += '<tr><th colspan="2">' + title + '</th></tr>';
            });

            innerHtml += '</thead>';
        }

        innerHtml += '<tbody>';

        bodyLines.forEach(function(body, i) {
            var colors = tooltip.labelColors[i];
            var style = 'background:' + colors.backgroundColor;
            style += '; border-color:' + colors.borderColor;
            style += '; border-width: 2px';
            var span = '<span class="dnJsChart-tooltip-key" style="' + style + '"></span>';
            innerHtml += '<tr><td>' + span + '</td><td class="dnJsChart-tooltip-value">' + body + '</td></tr>';
        });
        innerHtml += '</tbody>';

        var tableRoot = tooltipEl.querySelector('table');
        tableRoot.innerHTML = innerHtml;
    }

    var offsetToDocument = getOffsetToDocument(this._chart.canvas);

    var positionY = offsetToDocument.top;
    var positionX = offsetToDocument.left;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
};

var pieLegend = function(chart) {
    var legendHtml = [];
    legendHtml.push('<ul class="' + chart.config.type + '-legend">');

    for (var i=0; i < chart.data.datasets[0].data.length; i++) {
        legendHtml.push('<li><span style="background-color:' + chart.data.datasets[0].hoverBackgroundColor[i] + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;' + chart.data.labels[i] + '</span></li>');
    }

    legendHtml.push('</ul>');

    var legend = $(chart.canvas).next('.dnJsChart-pie-legend');

    if (typeof legend !== "undefined") {
        legend.html(legendHtml.join(""));
    }
};

var renderChart = function(chart) {

    var ctx = chart[0].getContext("2d");

    var labels =  chart.data('labels');
    var valueLabels = chart.data('valuelabels');
    var values = chart.data('values');

    var template = chart.data('template');

    Chart.defaults.global.elements.point.hitRadius = 5;

    var options;

    if (template === 'minimal') {
        options = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            animation: {
                duration: 0
            },
            hover: {
                animationDuration: 0
            },
            responsiveAnimationDuration: 0,
            scales: {
                yAxes: [{
                    display: false,
                    ticks: {
                        beginAtZero: true,
                        precision:0
                    }
                }],
                xAxes: [{
                    display: false
                }]
            },
            layout: {
                padding: {
                    bottom: 5,
                    left: 10,
                    right: 10,
                    top: 5
                }
            },
            tooltips: {
                enabled: false,
                custom: customTooltips,
                intersect: false,
                mode: 'label',
                callbacks: {
                    labelColor: function(tooltipItem, chart) {
                        var dataset = chart.config.data.datasets[tooltipItem.datasetIndex];
                        return {
                            borderColor: dataset.borderColor,
                            backgroundColor : dataset.borderColor
                        };
                    },
                    label: function(tooltipItem, data) {

                        return " " + tooltipItem.yLabel > 0 ? tooltipItem.yLabel : "0";
                    }
                },
                position: 'nearest'
            }
        };
    } else {
        options = {
            legend: {
                display: false
            },
            animation: {
                duration: 0
            },
            hover: {
                animationDuration: 0
            },
            responsiveAnimationDuration: 0,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        precision:0
                    }
                }]
            },
            tooltips: {
                enabled: false,
                custom: customTooltips,
                intersect: false,
                mode: 'label',
                callbacks: {
                    labelColor: function(tooltipItem, chart) {
                        var dataset = chart.config.data.datasets[tooltipItem.datasetIndex];
                        return {
                            borderColor: dataset.borderColor,
                            backgroundColor : dataset.borderColor
                        };
                    },
                    label: function(tooltipItem, data) {
                        return " " + tooltipItem.yLabel > 0 ? tooltipItem.yLabel : "0";
                    }
                },
                position: 'nearest'
            },
            legendCallback: lineLegend
        };
    }

    var data = generateChartJsData(labels, valueLabels, values);

    var myLineChart = new Chart(ctx, {
        type: 'line',
        data: data,
        options: options
    });
    myLineChart.generateLegend()
};


var renderPie = function(chart) {

    var labels = chart.data('labels');
    var values = chart.data('values');
    var colorNumber = chart.data('color-numbers');

    var ctx2 = chart.get(0).getContext("2d");

    var backgroundColor = [];
    var backgroundColorHover = [];

    for (var i in labels) {
        var bgColor = "rgba(color,0.6)".replace("color",(typeof colorNumber !== "undefined") ? chartJscolors[colorNumber[i]] : chartJscolors[i]);
        var bgColorHover = "rgba(color,1)".replace("color",(typeof colorNumber !== "undefined") ? chartJscolors[colorNumber[i]] : chartJscolors[i]);
        backgroundColor.push(bgColor);
        backgroundColorHover.push(bgColorHover);
    }

    var options = {
        legend: {
            display: false
        },
        animation: {
            duration: 0
        },
        hover: {
            animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        legendCallback: pieLegend,
        tooltips: {
            enabled: false,
            custom: customTooltips,
            callbacks: {
                label: function(tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                    });
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = Math.round(((currentValue/total) * 100));
                    return data.labels[tooltipItem.index] + ": " + percentage + "%";
                }
            }
        }
    };

    var data = {
        datasets: [{
            data: values,
            backgroundColor: backgroundColor,
            hoverBackgroundColor: backgroundColorHover
        }],

        labels: labels
    };

    var myPieChart = new Chart(ctx2, {
        type: 'pie',
        data: data,
        options: options
    });

    myPieChart.generateLegend();
};


var generateChartJsData = function(labels, valueLabels, values) {
    var datasets = [];

    var pointRadius = labels.length < 30 ? 2 : 0;

    for (var i in valueLabels) {
        datasets.push({
            label: valueLabels[i],
            backgroundColor: valueLabels[i] === translationTo.trendlineLabel ? "rgba(0,0,0,0)" : "rgba(color,0.2)".replace("color",chartJscolors[i]),
            borderColor: "rgba(color,1)".replace("color",chartJscolors[i]),
            pointBorderColor: "rgba(color,1)".replace("color",chartJscolors[i]),
            pointBackgroundColor: "rgba(color,1)".replace("color",chartJscolors[i]),
            pointRadius: pointRadius,
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "#FFF",
            borderWidth: 2,
            data: values[i],
            lineTension: 0.1
        });
    }
    var data = {
        labels: labels,
        datasets: datasets
    };

    return data;
};

var getChartJsById = function (id) {

    var chart = null;

    Chart.helpers.each(Chart.instances, function(instance){

        if (id === instance.chart.canvas.id) {
            chart = instance.chart;
        }
    });

    return chart;

};

var updateChartJsChart = function(chart, labels, valueLabels, values) {

    var data = generateChartJsData(labels, valueLabels, values);

    chart.data.labels = data.labels;
    chart.data.datasets = data.datasets;
    chart.update();
    chart.generateLegend();
};

var renderUnrenderedCharts = function() {
    $(".dnJsChart-chart").each(function () {
        if (!$(this).hasClass('chartjs-render-monitor')) {
            renderChart($(this));
        }
    });
};

var renderUInrenderedPie = function() {
    $(".dnJsChart-pie").each(function() {
        if (!$(this).hasClass('chartjs-render-monitor')) {
            renderPie($(this));
        }
    });
};

jQuery(document).ready(function($) {
    renderUnrenderedCharts();
});

jQuery(document).ready(function($) {
    renderUInrenderedPie();
});
